import { PlaceholderTabConfig } from './components/PlaceholderTabPanel';

export interface IncomeExpenseTabDefinition {
  id: string;
  label: string;
  panel: PlaceholderTabConfig;
}

export const REVENUE_ACTIVITY_TABS: IncomeExpenseTabDefinition[] = [
  {
    id: 'activities',
    label: 'Hoạt động thu',
    panel: {
      showCheckbox: true,
      filterFields: [
        'Loại phiếu thu',
        'Block',
        'Căn hộ',
        'Địa chỉ thu',
        'Từ',
        'Đến',
        'Kỳ báo cáo',
        'Tìm kiếm theo mã/tên phiếu',
      ],
      summaryCards: [
        { label: 'Tổng thu', value: '0đ' },
        { label: 'Đề nghị', value: '0đ' },
        { label: 'Đề nghị đã hủy', value: '0đ' },
      ],
      columns: [
        'Địa chỉ thu',
        'Căn hộ thu',
        'Loại phiếu thu',
        'Tên phiếu',
        'Kỳ báo cáo',
        'Lý do',
        'Phiếu đề nghị',
        'Ngày thực thu',
        'Ngày tạo',
        'Dự toán',
      ],
    },
  },
  {
    id: 'history',
    label: 'Lịch sử',
    panel: {
      columns: ['Thời gian', 'Thao tác', 'Số bút toán', 'Chi tiết', 'Người thực hiện'],
      emptyMessage: 'Chưa có lịch sử sửa/huỷ phiếu thu',
    },
  },
  {
    id: 'plans',
    label: 'Dự toán thu',
    panel: {
      filterFields: ['Căn hộ', 'Hợp đồng', 'Tài khoản dự án', 'Trạng thái'],
      columns: [
        'Tên',
        'Địa chỉ',
        'Hợp đồng',
        'Ngày bắt đầu',
        'Ngày kết thúc',
        'Loại',
        'Tài khoản',
        'Doanh thu ước tính',
      ],
    },
  },
  {
    id: 'categories',
    label: 'Loại thu',
    panel: {
      columns: ['Mã', 'Tên', 'Thao tác'],
      emptyMessage: 'Chưa có loại thu nào',
    },
  },
];

export const EXPENDITURE_ACTIVITY_TABS: IncomeExpenseTabDefinition[] = [
  {
    id: 'activities',
    label: 'Hoạt động chi',
    panel: {
      showCheckbox: true,
      filterFields: [
        'Loại phiếu chi',
        'Block',
        'Căn hộ',
        'Địa chỉ chi',
        'Từ',
        'Đến',
        'Kỳ báo cáo',
        'Tìm kiếm theo mã/tên phiếu',
      ],
      summaryCards: [
        { label: 'Tổng chi', value: '0đ' },
        { label: 'Đề nghị', value: '0đ' },
        { label: 'Đề nghị đã hủy', value: '0đ' },
      ],
      columns: [
        'Địa chỉ chi',
        'Căn hộ chi',
        'Loại phiếu chi',
        'Tên phiếu',
        'Kỳ báo cáo',
        'Lý do',
        'Phiếu đề nghị',
        'Ngày thực chi',
        'Ngày tạo',
        'Dự toán',
      ],
    },
  },
  {
    id: 'history',
    label: 'Lịch sử',
    panel: {
      columns: ['Thời gian', 'Thao tác', 'Số bút toán', 'Chi tiết', 'Người thực hiện'],
      emptyMessage: 'Chưa có lịch sử sửa/huỷ phiếu chi',
    },
  },
  {
    id: 'plans',
    label: 'Dự toán chi',
    panel: {
      filterFields: ['Căn hộ', 'Hợp đồng', 'Tài khoản dự án', 'Trạng thái'],
      columns: [
        'Tên',
        'Địa chỉ',
        'Hợp đồng',
        'Ngày bắt đầu',
        'Ngày kết thúc',
        'Loại',
        'Tài khoản',
        'Chi phí ước tính',
      ],
    },
  },
  {
    id: 'categories',
    label: 'Loại chi',
    panel: {
      columns: ['Mã', 'Tên', 'Thao tác'],
      emptyMessage: 'Chưa có loại chi nào',
    },
  },
];

export const SUMMARY_TABS: IncomeExpenseTabDefinition[] = [
  {
    id: 'income-expense-summary',
    label: 'Báo cáo tổng hợp thu chi',
    panel: {
      filterFields: ['Chung cư', 'Kỳ báo cáo'],
      columns: ['Nội dung', 'ĐVT', 'Kỳ trước', 'Kỳ này'],
    },
  },
  {
    id: 'income-expense-cash-flow',
    label: 'Tổng hợp tiền thu chi',
    panel: {
      filterFields: ['Chung cư', 'Kỳ báo cáo'],
      columns: ['Nội dung', 'Số dư đầu kỳ', 'Thu', 'Chi', 'Tồn cuối kỳ'],
    },
  },
  {
    id: 'income-expense-detail',
    label: 'Chi tiết thu chi',
    panel: {
      filterFields: ['Chung cư', 'Kỳ báo cáo', 'Tài khoản dự án', 'Hình thức'],
      columns: ['Ngày', 'Loại', 'Tên phiếu', 'Căn hộ', 'Tài khoản', 'Số tiền', 'Diễn giải'],
    },
  },
  {
    id: 'receivable-debt',
    label: 'Báo cáo tổng hợp công nợ',
    panel: {
      filterFields: ['Chung cư', 'Block', 'Căn hộ', 'Kỳ báo cáo', 'Loại phí'],
      columns: ['Căn hộ', 'Cư dân', 'Loại phí', 'Kỳ', 'Phải thu', 'Đã thu', 'Còn nợ'],
    },
  },
  {
    id: 'service-fee-detail',
    label: 'Chi tiết tính phí dịch vụ',
    panel: {
      filterFields: ['Chung cư', 'Căn hộ', 'Loại phí', 'Kỳ báo cáo'],
      columns: ['Căn hộ', 'Loại phí', 'Kỳ', 'Số lượng', 'Đơn giá', 'Thành tiền', 'Trạng thái'],
    },
  },
  {
    id: 'fee-detail',
    label: 'Chi tiết theo phí',
    panel: {
      filterFields: ['Chung cư', 'Loại phí', 'Kỳ báo cáo'],
      columns: ['Loại phí', 'Kỳ', 'Số căn hộ', 'Tổng phải thu', 'Tổng đã thu', 'Tổng còn nợ'],
    },
  },
];

export const BANK_ACCOUNT_TABS: IncomeExpenseTabDefinition[] = [
  {
    id: 'project',
    label: 'Tài khoản dự án',
    panel: {
      filterFields: ['Chung cư', 'Ngân hàng', 'Trạng thái'],
      columns: ['Tên tài khoản', 'Số tài khoản', 'Ngân hàng', 'Chủ tài khoản', 'Chung cư', 'Trạng thái', 'Thao tác'],
    },
  },
  {
    id: 'apartment',
    label: 'Tài khoản căn hộ',
    panel: {
      filterFields: ['Chung cư', 'Căn hộ', 'Ngân hàng'],
      columns: ['Căn hộ', 'Tên tài khoản', 'Số tài khoản', 'Ngân hàng', 'Chủ tài khoản', 'Thao tác'],
    },
  },
];

export const FINANCIAL_REPORT_TABS: IncomeExpenseTabDefinition[] = [
  {
    id: 'debt',
    label: 'Báo cáo công nợ',
    panel: {
      filterFields: ['Chung cư', 'Block', 'Kỳ báo cáo', 'Loại phí'],
      columns: ['Căn hộ', 'Cư dân', 'Kỳ', 'Phải thu', 'Đã thu', 'Còn nợ', 'Ghi chú'],
    },
  },
  {
    id: 'fee-type',
    label: 'Báo cáo loại phí',
    panel: {
      filterFields: ['Chung cư', 'Kỳ báo cáo', 'Loại phí'],
      columns: ['Loại phí', 'Kỳ', 'Số căn hộ', 'Tổng phải thu', 'Tổng đã thu', 'Tỷ lệ thu'],
    },
  },
  {
    id: 'daily-detail',
    label: 'Báo cáo thu chi ngày chi tiết',
    panel: {
      filterFields: ['Từ', 'Đến', 'Chung cư', 'Tài khoản'],
      columns: ['Ngày', 'Mã phiếu', 'Loại', 'Nội dung', 'Thu', 'Chi', 'Số dư', 'Tài khoản'],
    },
  },
];

export const DATA_IMPORT_TABS: IncomeExpenseTabDefinition[] = [
  {
    id: 'revenue',
    label: 'Khoản thu',
    panel: {
      columns: ['Tên file', 'Ngày import', 'Số dòng', 'Thành công', 'Lỗi', 'Người import', 'Trạng thái'],
      emptyMessage: 'Chưa có lịch sử import khoản thu',
    },
  },
  {
    id: 'expenditure',
    label: 'Khoản chi',
    panel: {
      columns: ['Tên file', 'Ngày import', 'Số dòng', 'Thành công', 'Lỗi', 'Người import', 'Trạng thái'],
      emptyMessage: 'Chưa có lịch sử import khoản chi',
    },
  },
  {
    id: 'revenue-plans',
    label: 'Dự toán thu',
    panel: {
      columns: ['Tên file', 'Ngày import', 'Số dòng', 'Thành công', 'Lỗi', 'Người import', 'Trạng thái'],
      emptyMessage: 'Chưa có lịch sử import dự toán thu',
    },
  },
];
